import {
  AuthenticatedExternalUserRoutes,
  CertificationWorkflowRoutes,
  DafUploadRoutes,
  DafVmidRoutes,
  HOME_NAVIGATION,
  RESOURCES,
  UserSettingRoutes
} from "_constants/PageRoutes";
import MCSSideNavPanel from "components/MCSSideNavPanel";
import { useAuthContextUser } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function AuthenticatedUserNavPanel(props) {
  const location = useLocation();
  const user = useAuthContextUser();
  const subscriptionManagementRoutes = [AuthenticatedExternalUserRoutes.STORE_PURCHASE, AuthenticatedExternalUserRoutes.SUBSCRIPTIONS];
  const threeDsDafRoutes = [DafUploadRoutes.DAF_UPLOAD, DafUploadRoutes.DAF_UPLOAD_LIST, DafUploadRoutes.DAF_UPLOAD_REQUEST, DafVmidRoutes.DAF_VMID_LIST, DafVmidRoutes.DAF_ACQUIRER_VMID_LIST];
  const settingRoutes = [UserSettingRoutes.USER_ACCOUNT_INFO, UserSettingRoutes.USER_EMAIL_NOTIFICATION, UserSettingRoutes.COMPANY_CONTACTS, UserSettingRoutes.RESOURCES];
  const certificationWorkflowRoutes = [CertificationWorkflowRoutes.CERTIFICATION_PACKAGES_LIST, CertificationWorkflowRoutes.CERTIFICATION_VSTS_ACCESS]

  const [tabSelected, setTabSelected] = useState(0);
  const isPath = (el) => { return location.pathname === el; }
  const [storeGroup, setStoreGroup] = useState(subscriptionManagementRoutes.findIndex(isPath) !== -1);
  const [threeDsDafGroup, setThreeDsDafGroup] = useState(threeDsDafRoutes.findIndex(isPath) !== -1);
  const [settingsGroup, setSettingsGroup] = useState(settingRoutes.findIndex(isPath) !== -1);
  const [certificationWorkflowGroup, setCertificationWorkflowGroup] = useState(certificationWorkflowRoutes.findIndex(isPath) !== -1); // [CertificationWorkflowRoutes.CERTIFICATION_WORKFLOW, CertificationWorkflowRoutes.CERTIFICATION_WORKFLOW_LIST, CertificationWorkflowRoutes.CERTIFICATION_WORKFLOW_REQUEST

  const userMenuList = [
    {
      type: "item",
      iconName: "home",
      label: user && user.navigation && user.navigation.dashboardMenu ? "Dashboard" : "Home",
      route: HOME_NAVIGATION,
    },
    {
      type: "menu",
      visible: user && user.navigation && user.navigation.storeMenu,
      iconName: "offers",
      label: "VSS Store",
      parentState: storeGroup,
      openParent: setStoreGroup,
    },
    {
      type: "child",
      visible: user && user.navigation && user.navigation.storeMenu,
      iconName: "cart",
      label: "Purchase Subscriptions",
      parentState: storeGroup,
      route: AuthenticatedExternalUserRoutes.STORE_PURCHASE,
      openParent: setStoreGroup,
    },
    {
      type: "child",
      visible: user && user.isSubscriptionManager,
      iconName: "view-list",
      label: "View Subscriptions",
      parentState: storeGroup,
      route: AuthenticatedExternalUserRoutes.SUBSCRIPTIONS,
      openParent: setStoreGroup,
    },
    {
      type: "menu",
      visible: user && user.navigation.certificationWorkflowMenu,
      iconName: "report-ready",
      label: "Visa Secure Certification",
      parentState: certificationWorkflowGroup,
      openParent: setCertificationWorkflowGroup
    },
    {
      type: "child",
      // if certificationWorkflowMenu = true, it also means that can see CertificationPackageList child menu
      visible: user && user.navigation.certificationWorkflowMenu,
      iconName: "portfolio",
      label: "Certification Packages",
      parentState: certificationWorkflowGroup,
      route: CertificationWorkflowRoutes.CERTIFICATION_PACKAGES_LIST,
      openParent: setCertificationWorkflowGroup
    },
    {
      type: "vstsSSOMenuItem",
      visible: user && user.navigation.vstsAccess,
      iconName: "sign-in",
      label: "VSTS Access",
      parentState: certificationWorkflowGroup,
      openParent: setCertificationWorkflowGroup,
    },
    {
      type: "menu",
      visible: user && user.navigation && user.navigation.dafMenu,
      iconName: "device-servers",
      label: "3DS DAF",
      parentState: threeDsDafGroup,
      openParent: setThreeDsDafGroup,
    },
    {
      type: "child",
      visible: user && user.navigation && user.navigation.dafUploadMenu,
      iconName: "file-upload",
      label: "Upload Acquirer File",
      parentState: threeDsDafGroup,
      route: DafUploadRoutes.DAF_UPLOAD,
      openParent: setThreeDsDafGroup,
    },
    {
      type: "child",
      visible: user && user.navigation && user.navigation.dafVmidMenu,
      iconName: "view-list",
      label: "View VMIDs",
      parentState: threeDsDafGroup,
      route: DafVmidRoutes.DAF_VMID_LIST,
      openParent: setThreeDsDafGroup,
    },
    {
      type: "child",
      visible: user && user.navigation && user.navigation.dafAcquirerVmidMenu,
      iconName: "view-list",
      label: "View VMIDs",
      parentState: threeDsDafGroup,
      route: DafVmidRoutes.DAF_ACQUIRER_VMID_LIST,
      openParent: setThreeDsDafGroup,
    },
    {
      type: "menu",
      visible: user && user.navigation && user.navigation.settingsMenu,
      iconName: "settings",
      label: "Settings",
      parentState: settingsGroup,
      openParent: setSettingsGroup,
    },
    {
      type: "child",
      iconName: "account",
      label: "Account Information",
      parentState: settingsGroup,
      route: UserSettingRoutes.USER_ACCOUNT_INFO,
      openParent: setSettingsGroup,
    },
    {
      type: "child",
      visible: user && user.navigation && user.navigation.settingsMenuEmailNotification,
      iconName: "email",
      label: "Email Notification",
      parentState: settingsGroup,
      route: UserSettingRoutes.USER_EMAIL_NOTIFICATION,
      openParent: setSettingsGroup,
    },
    {
      type: "child",
      visible: user && user.navigation && user.navigation.companyContacts,
      iconName: "contact",
      label: "Company Contacts",
      parentState: settingsGroup,
      route: UserSettingRoutes.COMPANY_CONTACTS,
      openParent: setSettingsGroup,
    },
    {
      type: "item",
      iconName: "connect",
      label: "Resources",
      route: RESOURCES,
    },
  ]
  useEffect(() => {
    const newTabSelected = userMenuList.findIndex(item => item.route === location.pathname);
    if (newTabSelected !== -1) {
      setTabSelected(newTabSelected);
    }
  }, [location]);

  return (
    <MCSSideNavPanel ariaLabel="User Vertical Site Navigation"
      collapsed={true}
      tabList={userMenuList}
      tabSelected={tabSelected}
      setTabSelected={setTabSelected}
    >
      {props.children}
    </MCSSideNavPanel>
  );
}

export default AuthenticatedUserNavPanel;
